export default {
  title: "Восстановление пароля",
  back: "Вернуться назад",
  submit: "Отправить",
  successMessage:
    "Если аккаунт с указанным адресом существует и адрес электронной почты подтверждён, мы отправим ссылку для восстановления пароля."
};
